import { readMiniTaskSoundEnabled } from '../../mini-tasks/soundEffects';

// Two light plings. Shorter, quieter and less ceremonial than Appreciation.
// Prepare only inside the teacher's submit gesture; do not replay after autoplay denial.
let context;
export function prepareBonusSound() {
  try {
    if (!readMiniTaskSoundEnabled()) return;
    const Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) return;
    if (!context || context.state === 'closed') context = new Audio();
    if (context.state === 'suspended') context.resume()?.catch(() => {});
  } catch (_) { /* Never fail the bonus operation because of sound. */ }
}
export function playBonusSound() {
  if (!readMiniTaskSoundEnabled() || context?.state !== 'running') return () => {};
  const nodes = [];
  let output;
  const stop = () => {
    nodes.forEach(node => { try { node.stop(); node.disconnect(); } catch (_) { /* Already stopped. */ } });
    try { output?.disconnect(); } catch (_) { /* Best effort. */ }
  };
  try {
    output = context.createGain();
    output.gain.value = 0.34;
    output.connect(context.destination);
    const start = context.currentTime + 0.015;
    [[783.99, 0, .22], [1046.5, .16, .35]].forEach(([frequency, offset, duration]) => {
      const tone = context.createOscillator();
      const envelope = context.createGain();
      tone.type = 'sine';
      tone.frequency.value = frequency;
      envelope.gain.setValueAtTime(.0001, start + offset);
      envelope.gain.exponentialRampToValueAtTime(.064, start + offset + .018);
      envelope.gain.exponentialRampToValueAtTime(.0001, start + offset + duration);
      tone.connect(envelope); envelope.connect(output);
      tone.start(start + offset); tone.stop(start + offset + duration);
      tone.onended = () => { tone.disconnect(); envelope.disconnect(); };
      nodes.push(tone);
    });
    nodes[nodes.length - 1].addEventListener('ended', () => output.disconnect(), { once:true });
  } catch (_) { stop(); }
  return stop;
}
